/* eslint-disable @typescript-eslint/no-explicit-any */
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseDatePicker } from 'app/components/common/pickers/BaseDatePicker'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { t } from 'i18next'
import React from 'react'
import styled from 'styled-components'

import dayjs, { Dayjs } from 'dayjs'
import { IFilterDashboard } from '..'

export enum RangeTimeEnum {
  CHOOSE_DAY = 'choose_day',
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  THIS_WEEK = 'this_week',
  LAST_WEEK = 'last_week',
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  THIS_YEAR = 'this_year',
}

interface IProps {
  filter: IFilterDashboard
  onChange?: (filter: IFilterDashboard) => void
}

export const FilterLayout: React.FC<IProps> = ({ filter, onChange }) => {
  const onChangeRangeTime = (rangeTime: RangeTimeEnum) => {
    let startDate: Dayjs = dayjs()
    let endDate: Dayjs = dayjs()

    switch (rangeTime) {
      case RangeTimeEnum.TODAY:
        startDate = dayjs().startOf('day')
        endDate = dayjs().endOf('day')
        break

      case RangeTimeEnum.YESTERDAY:
        startDate = dayjs().subtract(1, 'day').startOf('day')
        endDate = dayjs().subtract(1, 'day').endOf('day')
        break

      case RangeTimeEnum.THIS_WEEK:
        startDate = dayjs().startOf('week')
        endDate = dayjs().endOf('week')
        break

      case RangeTimeEnum.LAST_WEEK:
        startDate = dayjs().subtract(1, 'week').startOf('week')
        endDate = dayjs().subtract(1, 'week').endOf('week')
        break

      case RangeTimeEnum.THIS_MONTH:
        startDate = dayjs().startOf('month')
        endDate = dayjs().endOf('month')
        break

      case RangeTimeEnum.LAST_MONTH:
        startDate = dayjs().subtract(1, 'month').startOf('month')
        endDate = dayjs().subtract(1, 'month').endOf('month')
        break

      case RangeTimeEnum.THIS_YEAR:
        startDate = dayjs().startOf('year')
        endDate = dayjs().endOf('year')
        break

      case RangeTimeEnum.CHOOSE_DAY:
        // Không xử lý sẵn, người dùng sẽ chọn ngày
        onChange?.({
          ...filter,
          rangeTime,
        })
        return
    }

    onChange?.({
      ...filter,
      startDateDayJs: startDate,
      endDateDayJs: endDate,
      rangeTime,
    })
  }

  const onChangeStart = (startDate: Dayjs | null) => {
    onChange &&
      onChange({
        ...filter,
        startDateDayJs: startDate,
        rangeTime: RangeTimeEnum.CHOOSE_DAY,
      })
  }

  const onChangeEnd = (endDate: Dayjs | null) => {
    onChange &&
      onChange({
        ...filter,
        endDateDayJs: endDate,
        rangeTime: RangeTimeEnum.CHOOSE_DAY,
      })
  }

  const disabledEndDate = (current: Dayjs) => {
    if (!filter?.startDateDayJs) {
      return false
    }
    return current && current.isBefore(filter?.startDateDayJs, 'day')
  }

  const disabledStartDate = (current: Dayjs) => {
    if (!filter?.endDateDayJs) {
      return false
    }
    return current && current.isAfter(filter?.endDateDayJs, 'day')
  }

  return (
    <BaseForm>
      <RootWrapper gutter={[16, 4]} align={'middle'} justify={'start'}>
        <BaseCol xl={7}>
          <BaseFormItem hiddenLabel>
            <BaseSelectWrapper
              options={Object?.values(RangeTimeEnum).map(itm => ({
                label: t(itm),
                value: itm,
              }))}
              allowClear={false}
              filterSort={() => 0}
              defaultValue={RangeTimeEnum.THIS_YEAR}
              value={filter?.rangeTime}
              onChange={value => onChangeRangeTime(value as RangeTimeEnum)}
              placeholder={'Chọn khoảng thời gian'}
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <Picker
              format={'DD-MM-YYYY'}
              placeholder={t(R.strings.from_date)}
              onChange={onChangeStart}
              showTime={false}
              disabledDate={disabledStartDate}
              value={filter?.startDateDayJs}
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <Picker
              format={'DD-MM-YYYY'}
              placeholder={t(R.strings.to_date)}
              onChange={onChangeEnd}
              disabledDate={disabledEndDate}
              value={filter?.endDateDayJs}
            />
          </BaseFormItem>
        </BaseCol>
      </RootWrapper>
    </BaseForm>
  )
}

const RootWrapper = styled(BaseRow)`
  background-color: white;
  padding: 8px;
  border-radius: 8px;
`

const Picker = styled(BaseDatePicker)`
  width: 100%;
  border: 1px solid ${convertedVariables.neutralBlack9Color};
  padding-left: 4px !important;
  &:hover {
    border: 1px solid ${convertedVariables.neutralBlack9Color};
  }
`

const BaseSelectWrapper = styled(BaseSelect)`
  width: 100%;
  .ant-select-selector {
    padding-left: 4px !important;
  }
`

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px !important;
`
